import React from 'react';
import { useLocation } from 'react-router-dom';

import BackOfficeUserCreateButton from 'components/buttons/BackOfficeUserCreateButton';
import BackOfficeUserCreateDrawer from 'components/drawers/BackOfficeUserCreateDrawer';
import BackOfficeUserEditDrawer from 'components/drawers/BackOfficeUserEditDrawer';
import BackOfficeSection from 'components/features/backOffice/BackOfficeSection';
import BackOfficeInvitationsRequest from 'components/requests/BackOfficeInvitationsRequest';
import BackOfficeInvitationsTable from 'components/tables/BackOfficeInvitationsTable';
import { useApplyCachedSearchParams } from 'utils/Router/use-apply-cached-search-params';

export default function BackOfficeInvitations() {
  const { pathname } = useLocation();
  useApplyCachedSearchParams(pathname);
  return (
    <BackOfficeSection
      actions={<BackOfficeUserCreateButton />}
      table={<BackOfficeInvitationsTable />}
      searchInputPlaceholder="Search by email"
    >
      <BackOfficeInvitationsRequest />
      <BackOfficeUserCreateDrawer />
      <BackOfficeUserEditDrawer />
    </BackOfficeSection>
  );
}
